export default __webpack_public_path__ + "static/media/bulk-mgs-image.65782e4c.webp";